/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import moment from 'moment';
import cx from 'classnames';
import { OSMMap } from 'volto-venue';
import { Grid, Container } from 'semantic-ui-react';
import {
  ListingLinkMore,
  PresetWrapper,
  ListingHeader,
} from '@package/components';
import { ProjectCard } from '@package/components';

const messages = defineMessages({
  default_detail_link: {
    id: 'Vedi',
    defaultMessage: 'Vedi',
  },
  no_markers: {
    id: 'Non ci sono punti da mostrare sulla mappa',
    defaultMessage: 'Non ci sono punti da mostrare sulla mappa',
  },
});

const MapTemplate = (props) => {
  const { items, show_map_full_width, map_size = 'medium' } = props;
  const intl = useIntl();

  moment.locale(intl.locale);

  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    let points = items
      .filter(
        (item) =>
          (item.latitude &&
            item.longitude &&
            item.latitude !== 0 &&
            item.longitude !== 0) ||
          (item.geolocation && //for backward compatibility. To remove on next release.
            item.geolocation?.latitude &&
            item.geolocation?.longitude &&
            item.geolocation?.latitude !== 0 &&
            item.geolocation?.longitude !== 0),
      )
      .map((item) => {
        return {
          title: item.title,
          ...(item.geolocation
            ? item.geolocation
            : { latitude: item.latitude, longitude: item.longitude }),
          popupContent: (
            <div>
              <ProjectCard {...item} have_description={true} have_cta={true} />
            </div>
          ),
        };
      });

    setMarkers(points);
  }, [items, show_map_full_width, map_size]);

  return (
    <PresetWrapper {...props} className="map-template">
      <Container className="px-4">
        <ListingHeader {...props} />
        {items?.length > 0 && markers?.length > 0 ? (
          <Grid
            className={cx('mb-4 map-wrapper', {
              'full-width': show_map_full_width,
              ['size_' + map_size]: map_size,
            })}
          >
            <Grid.Row>
              <Grid.Column>
                <OSMMap
                  key={`map-${show_map_full_width}-${map_size}`}
                  markers={markers}
                  showTooltip={false}
                  showPopup={true}
                  cluster={true}
                  mapOptions={{
                    scrollWheelZoom: false,
                    // tap: false,
                    // dragging: false,
                  }}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        ) : (
          intl.formatMessage(messages.no_markers)
        )}

        <ListingLinkMore {...props} />
      </Container>
    </PresetWrapper>
  );
};

MapTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
  linkTitle: PropTypes.any,
  linkHref: PropTypes.any,
};

export default MapTemplate;
